import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changePasswordUser } from '../../rtk/thunks/authThunk';
import './forgotPassword.css';
import { NavLink } from 'react-router-dom';

const ChangePassword = () => {
    const dispatch = useDispatch();
    const { loading, error, message } = useSelector((state) => state.auth);
    const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
    const [localError, setLocalError] = useState('');

    const formatError = (value) => {
        if (!value) return '';
        if (typeof value === 'string') return value;
        if (Array.isArray(value)) return value.filter(Boolean).join(' ');

        return (
            value.detail ||
            value.message ||
            value.non_field_errors?.[0] ||
            value.old_password?.[0] ||
            value.new_password?.[0] ||
            value.confirm_password?.[0] ||
            Object.values(value)
                .flat()
                .find((item) => typeof item === 'string' && item.trim()) ||
            'Password change failed. Please try again.'
        );
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLocalError('');
        if (form.new_password !== form.confirm_password) {
            setLocalError('Passwords do not match.');
            return;
        }
        try {
            // send confirm_password as backend requires it
            await dispatch(changePasswordUser({ old_password: form.current_password, new_password: form.new_password, confirm_password: form.confirm_password })).unwrap();
            setForm({ current_password: '', new_password: '', confirm_password: '' });
        } catch (err) {
            // handled in slice
        }
    };

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-card">
                <div className="forgot-password-header">
                    <p className="forgot-password-eyebrow">Security</p>
                    <h2>Change password</h2>
                    <p className="forgot-password-subtitle">Change your account password.</p>
                </div>
                <form className="forgot-password-form" onSubmit={handleSubmit}>
                    <div className="input-group">
                        <input type="password" name="current_password" placeholder="Current password" value={form.current_password} onChange={handleChange} required />
                    </div>
                    <div className="input-group">
                        <input type="password" name="new_password" placeholder="New password" value={form.new_password} onChange={handleChange} required />
                    </div>
                    <div className="input-group">
                        <input type="password" name="confirm_password" placeholder="Confirm new password" value={form.confirm_password} onChange={handleChange} required />
                    </div>
                    {localError && <p className="form-error">{localError}</p>}
                    {error && <p className="form-error">{formatError(error)}</p>}
                    {message && <p className="form-success">{message}</p>}
                    <button type="submit" className="forgot-password-button" disabled={loading}>{loading ? 'Changing...' : 'Change password'}</button>
                    <p className="forgot-password-link">Back to <NavLink to="/user-profile">Profile</NavLink></p>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
